import { render, staticRenderFns } from "./ForeignExchangeIndices.vue?vue&type=template&id=679ffd8d"
import script from "./ForeignExchangeIndices.vue?vue&type=script&lang=js"
export * from "./ForeignExchangeIndices.vue?vue&type=script&lang=js"
import style0 from "./ForeignExchangeIndices.vue?vue&type=style&index=0&id=679ffd8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports